import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './Operator.module.css'
import axios from 'axios';

const Operator = () => {
    const [operators, setOperators] = useState([]);
    const navigate = useNavigate();

    const fetchOperators = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/tourism/operators`, { withCredentials: true });
            setOperators(response.data.operators);
            console.log("Operator data:", response.data.operators);
        } catch (error) {
            console.log("Error fetching operator data:", error);
        }
    }

    useEffect(() => {
        fetchOperators();
    }, []);

    const handleCardClick = (operator) => {
        navigate(`/tourism/operator/${operator.operator_id}`, {
            state: {
                image_url: operator.image_url // Send the signed URL directly
            }
        });
    };

    const formatRating = (rating) => {
        return parseFloat(rating).toFixed(1);
    };

    const getVerificationStatus = (isVerified) => {
        return isVerified === 1 ? "Verified" : "Pending";
    };

    const getStatusColor = (isVerified) => {
        return isVerified === 1 ? styles.verified : styles.notVerified;
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.head}>Tour Operators</h2>
            <div className={styles.operatormain}>
                {operators?.map((operator, index) => (
                    <div
                        key={operator.operator_id || index}
                        className={styles.operatorcard}
                        onClick={() => handleCardClick(operator)}
                    >
                        {/* Image/Logo Section */}
                        <div className={styles.imageContainer}>
                            {operator.image_url ? (
                                <img src={operator?.image_url} alt={operator.name} className={styles.operatorImage} />
                            ) : (
                                operator.name
                            )}
                        </div>

                        {/* Header with Name and Verification Status */}
                        <div className={styles.cardHeader}>
                            <h3 className={styles.operatorName}>{operator.name}</h3>
                            <span className={`${styles.verification} ${getStatusColor(operator.is_verified)}`}>
                                {getVerificationStatus(operator.is_verified)}
                            </span>
                        </div>

                        {/* Rating */}
                        <div className={styles.ratingSection}>
                            <span className={styles.rating}>⭐ {formatRating(operator.rating)}</span>
                            <span className={styles.reviews}>({operator.reviews || 0} reviews)</span>
                        </div>

                        {/* Brief Description */}
                        <p className={styles.description}>{operator.description}</p>

                        {/* Quick Stats */}
                        <div className={styles.quickStats}>
                            <div className={styles.statItem}>
                                <span className={styles.statLabel}>Since</span>
                                <span className={styles.statValue}>{operator.operating_since || 'N/A'}</span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.statLabel}>Location</span>
                                <span className={styles.statValue}>
                                    {operator.location ? operator.location.split(',')[0] : 'Unknown'}
                                </span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.statLabel}>Status</span>
                                <span className={styles.statValue}>
                                    {operator.is_verified ? 'Active' : 'Review'}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Operator